<template>
  <div class="qualificationCenter">
    <div class="center-right">
      <h1>行业协会</h1>
      <p>
        行业协会是一种民间性组织，它不属于政府的管理机构系列，而是政府与企业的桥梁和纽带。行业协会属于我国《民法》规定的社团法人，是我国民间组织社会团体的一种，即国际上统称的非政府机构，又称NGO，属非营利性机构。行业协会的任务是为其特定行业提供服务，并对其进行监督、协调和自律。
      </p>
      <div class="center-nav">
        <li
          class="change"
          :class="currentIndex == index ? 'active2' : ''"
          v-for="(item, index) in list"
          :key="item.id"
          @click="change2(index)"
        >
          <router-link :to="{ path: `${item.gopath}` }" href=""
            ><span :class="currentIndex == index ? 'activeColor' : 'color'"
              >{{ item.title }}<i></i></span
          ></router-link>
        </li>
        <span></span>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  name: "industry",
  data() {
    return {
      currentIndex: 0, //表示当前选项卡,
      list: [
        {
          id: 1, //用来代表每一个对象
          title: "智能化行业协会", //标题
          gopath: "/qualification/industry/security2"
        },
        {
          id: 2,
          title: "智能交通协会", //标题
          gopath: "/qualification/industry/rd11"
        },
        {
          id: 3,
          title: "其他行业协会", //标题
          gopath: "/qualification/industry/otherIndustries"
        }
      ]
    };
  },
  methods: {
    change2(index) {
      // console.log(this.currentIndex  + "@@@@@@@@@@" + index)
      // var iAll = document.getElementsByTagName("i")
      // console.log(iAll.length + "@@@")
      // for(var i = 0; i < iAll.length; i++){
      //   console.log("@@")
      //   iAll[i].className = "";
      // }
      // var top = document.getElementsByClassName('active2')
      // var i = top[0].firstElementChild.firstElementChild.firstElementChild;
      // console.log(top[0].firstElementChild)
      // i.className = "bgc";
      //用来实现切换功能
      //实现选项卡 切换操作 - 本质就是操作类名
      // 通过currentIndex操作
      this.currentIndex = index;
    }
  }
};
</script>
<style scoped>
@media screen and (max-width: 1285px) and (min-width: 950px) {
  body .center-right {
    /* width: 86%; */
    width: 80%;
    width: 100%;
  }
}
@media screen and (max-width: 950px) {
  body .center-right {
    width: 82%;
    width: 100%;
  }
}
li {
  width: 102px;
  list-style: none;
  margin-right: 54px;
  cursor: pointer;
}
.center-right {
  float: left;
  /* width: 1038px; */
}
.center-right h1 {
  margin-bottom: 31px;
  font-size: 31px;
  color: #140047;
  line-height: 39px;
  letter-spacing: 1.92px;
}
.activeColor {
  display: block;
  width: 95px;
  /* color: #140047; */
  font-size: 16px;
  line-height: 23px;
  white-space: nowrap;
  color: #140047;
  text-align: center;
}
.center-right .center-nav .color {
  display: block;
  width: 95px;
  /* color: #140047; */
  font-size: 16px;
  line-height: 23px;
  white-space: nowrap;
}
.center-right .center-nav .bgc {
  background-color: #140047;
}
.center-right .center-nav .active2 a span i {
  background-color: #140047;
  color: #140047;
  width: 120px;
}
.center-right p {
  margin-bottom: 40px;
  font-size: 16px;
  font-weight: 400;
  color: #01021b;
  line-height: 29px;
  letter-spacing: 0.96px;
  opacity: 0.72;
}
.center-right .center-nav {
  margin-bottom: 32px;
  display: flex;
  position: relative;
  height: 48px;
}
.center-right .center-nav a {
  width: 102px;
  height: 48px;
  margin-right: 54px;
  font-size: 20px;
  font-weight: 550;
  color: rgba(0, 0, 0, 0.3);
  line-height: 28px;
  letter-spacing: 0.96px;
  transition: color 0.3s;
}
.center-right .center-nav span i {
  display: block;
  margin-top: 14px;
  width: 100%;
  height: 4px;
  background: transparent;
}
.center-right .center-nav span:nth-child(3) {
  position: absolute;
  top: 36px;
  width: 100%;
  height: 4px;
  background-color: rgba(239, 239, 242, 0.5);
  z-index: -1;
}
.center-right .center-nav a:hover {
  color: #140047;
}
.center-right .center-nav a:hover i {
  background-color: #140047;
}
.center-right ul {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.center-right ul li {
  width: 22%;
  box-shadow: 0rem 0.9984px 10.0032px 0rem rgba(206, 206, 206, 0.5);
}
.center-right ul li .img {
  position: relative;
  height: 240px;
  background-color: #f1f4fb;
}
.center-right ul li .img img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 80%;
  object-fit: contain;
}
.center-right ul li .text {
  padding: 20px 52px 20px 20px;
  height: 112px;
  background-color: rgba(255, 255, 255, 0.88);
  font-size: 18px;
  font-weight: 550;
  color: rgba(0, 0, 0, 0.58);
  line-height: 36px;
  letter-spacing: 0.96px;
}
</style>



// WEBPACK FOOTER //
// src/components/qn/industry.vue